<div class="m-0 p-0">
<app-hero></app-hero>
<div class="container mt-2" *ngIf="showDetails">
  <div class="row pt-3 pb-5 gray mb-3">
    <div class="col-lg-6 ps-4">
      <label class="header-text mt-3 mb-3">See what you can save today.</label>
      <div class="ms-2 me-2">
        <p class="text-sm-roboto-serif">
          {{ details?.salesPlanMarketingDetails?.savingsText?.at(0)?.value.at(0) }}
        </p>
        <ul class="savings-text ps-3" *ngFor="let item of details?.salesPlanMarketingDetails?.savingsList ; let ii = index ">
          <li *ngFor="let items of item.value[0] ; let a = index">{{ items }}</li>
        </ul>
        <div class="d-sm-block d-flex justify-content-center">
          <div class="btn btn-lg mt-3" style="width: 250px;font-size: 16px;" routerLink="summary-of-discounts" id="viewSavingsButton">view savings</div>
        </div>
      </div>
      <div *ngIf="em?.isAdminBy === 'careingtonca'" class="savings-text mt-3">
        For information regarding ancillary benefits including UNOA please <a href="/benefit-info">click here</a>.
      </div>
    </div>
    <div class="col-lg-6 p-4">
      <div class="row">
        <div class="col-12 box" style="padding-left: 1px;padding-right: 1px;">
          <div class="row mb-1 mt-2">
            <div class="col-12">
              <table style="width:460px">
                <tr>
                  <td class="box-header-text-white" style="width:220px">&nbsp;</td>
                  <td class="box-header-text-white" style="width:80px">Average Fee without Plan†</td>
                  <td class="box-header-text-white" style="width:80px">Average Fee <br> with Plan††</td>
                  <td class="box-header-text-white pe-1" style="width:80px">Member <br> Savings¶</td>
                </tr>
              </table>
            </div>
          </div>
            <div class="row box-row" *ngFor="let item of details?.salesPlanMarketingDetails?.codes ; let ii = index ">
              <div class="col-12">
                <table style="width:100%">
                  <tr>
                    <td class="box-text" style="width:220px;margin-top:15%" [innerHTML]="item.itemName"></td>
                    <td class="text-center box-text vertical-center" style="width:80px" *ngFor="let items of item.value[0] ; let a = index">{{ items }}</td>
                  </tr>
                </table>
              </div>
            </div>
        </div>
      </div>
      <div class="row" *ngIf="details?.salesPlanMarketingDetails?.savingsFooter">
        <div class="col-12 grid-text mt-2 text-center">
          {{details?.salesPlanMarketingDetails?.savingsFooter[0].value[0]}}
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-5">
    <div class="col-12 mt-2 header-text-bold center">
      Start saving on the treatment you need
    </div>
  </div>
  <div class="row g-3">
    <div class="col-md-4 px-sm-2 px-4" *ngFor="let option of em.planOptions?.templates[0]?.planOptions; let i = index">
      <app-card-item>
        <label class="text-center" style="width: 100%">{{option.coverageLevelName}}</label>
        <div class="card-price center"><span class="dollar-sign mb-1">$</span> {{option.fee + option.adminFee}}</div>
        <div class="duration text-center full-width">for 12 months</div>
        <div class="text-xm-roboto text-center full-width mb-2">Applicable Taxes May Apply*</div>
        <div class="btn btn-lg full-width text-center" style="font-size:16px;" routerLink="purchase" id="savingButton{{i}}">Start Saving</div>
      </app-card-item>
    </div>
  </div>
  <div class="row mt-3 mb-2">
    <div class="col-12">
      <div class="footer-info-text full-width text-center mb-5 pb-4">
        * Price includes a one-time, non-refundable $15 administration fee.
      </div>
    </div>
  </div>
</div>
<div class="container-fluid p-0 m-0">
  <div class="row">
    <div class="col-12">
      <div class="container">
        <div class="row">
          <div class="col-1">&nbsp;</div>
          <div class="col-10 text-center mt-5 mb-3">
            <div class="bottom-header-text  mt-2 mb-3">
              More benefits for you — because oral health
              means better health!
            </div>
            <div class="footer-info-text text-center text-justify ms-5 me-5">
              In addition to discounts on general dentistry, other benefits include:
            </div>
          </div>
          <div class="col-1">&nbsp;</div>
        </div>
        <div class="row">
          <div class="col-md-2">&nbsp;</div>
          <div class="col-md-8">
            <ul>
              <li class="m-4 serif-16-text">
                <span class="teal-text">20-60% savings</span> on Mouth-Body Connection® procedures like oral cancer screenings, salivary lab tests and full-mouth periodontal treatment
              </li>
              <li class="m-4 serif-16-text">
                <span class="teal-text">20% discounts</span> on specialty care such as gum (periodontal) treatment, oral surgery, orthodontics, root canal treatment, cosmetic services like in-office teeth whitening and more
              </li>
              <li class="m-4 serif-16-text">
                <span class="teal-text">Additional benefits</span> for members with underlying health conditions
              </li>
            </ul>
          </div>
          <div class="col-md-2">&nbsp;</div>
        </div>
        <div class="row mb-5">
          <div class="col-1"></div>
          <div class="col-10 text-center mt-5 mb-3">
            <div class="bottom-header-text full-width mt-2 mb-3">
              Real-time visibility of benefits and costs
            </div>
            <div class="footer-info-text text-center text-justify ms-5 me-5 mb-3">
              Smile Generation Dental Plan provides you with real-time visibility to your treatment savings and costs—all on your phone.
              Make good decisions about your oral health and be informed every step of the way.
            </div>
          </div>
          <div class="col-1"></div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container-fluid p-0 m-0">
  <div class="row green-box">
    <div class="col-12">
      <div class="container">
        <div class="row mt-4 mb-4 justify-content-left">
          <div class="col-sm-8 green-box-text">
            Accepted exclusively at Smile Generation®-trusted offices in 24 states across the US.
          </div>
          <div class="col-sm-4 mt-1">
            <div class="btn btn-lg float-end" style="font-size:18px;width:225px;" routerLink="/find-a-dentist" id="dentistButton2" (click)="findDentist()">find a dentist</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container-fluid p-0 m-0">
  <div class="row dark-box">
    <div class="col-12 mt-5">
      <div class="container" *ngIf="!showContactSuccess && !showContactError">
        <div class="row">
          <div class="col-12 text-center mb-3">
            <span class="header-text-white">contact us</span>
          </div>
          <div class="col-12 text-center">
            <span class="small-header-text-white mb-1">
              Have questions? We’d love to help you. <br>
              {{info.telephoneNumber | phone}}   |  You can also submit the form below.
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-12">&nbsp;</div>
        </div>
        <form action="" [formGroup]="contactUs">
          <div class="row mb-5 mt-1">
            <div class="col-sm-2"></div>
            <div class="col-sm-8">
              <div class="row mt-2">
                <div class="col-sm-6">
                  <label for="contact-us-name" class="form-label">Name*</label>
                  <input type="text" name="name" id="contact-us-name" class="form-control" formControlName="name">
                  <div *ngIf="contactUs.get('name')?.invalid && (contactUs.get('name')?.dirty || contactUs.get('name')?.touched)" class="error-message">
                    Please Enter Your Name
                  </div>
                </div>
                <div class="col-sm-6">
                  <label for="contact-us-email" class="form-label">Email Address*</label>
                  <input type="text" name="email" id="contact-us-email" class="form-control" formControlName="email">
                  <div *ngIf="contactUs.get('email')?.invalid && (contactUs.get('email')?.dirty || contactUs.get('email')?.touched)" class="error-message">
                    Please Enter A Valid Email
                  </div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-12">
                  <label for="contact-us-message" class="form-label">Message*</label>
                  <textarea name="message" id="contact-us-message" rows="8" class="form-control" formControlName="message"></textarea>
                  <div *ngIf="contactUs.get('message')?.invalid && (contactUs.get('message')?.dirty || contactUs.get('message')?.touched)" class="error-message">
                    Please Enter A Message
                  </div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-12">
                  <span class="red-message">
                    By submitting this form you agree to being contacted. You can unsubscribe anytime. 
                    Your <a href="https://wellfit.com/wellfits-privacy-policy/" class="red-link" target="_blank">privacy</a> is important.
                  </span>
                </div>
              </div>
              <div class="row mt-3 mb-3">
                <div class="col-12 text-center">
                    <button id="btn-contact-us-send" class="btn btn-lg" style="width:261px;font-size:16px;" [disabled]="contactUs.invalid" (click)="sendForm()">Submit</button>
                </div>
              </div>
            </div>
            <div class="col-sm-2"></div>
          </div>

        </form>
      </div>
      <div class="container mt-5 mb-5">
        <div class="col-12" *ngIf="showContactSuccess">
          <div class="row">
            <div class="col-2"></div>
            <div class="col-8 center">
              <img class="icon-msg-sent" src="/assets/images/contact-us/ic-plane.svg" alt="Sent" />
              <div class="message center">
                <span>Message Sent!</span>
              </div>
            </div>
            <div class="col-2"></div>
          </div>
        </div>
        <div class="col-12 " *ngIf="showContactError">
          <div class="col-12 center">
            <div class="message center mt-5 mb-5">
              <span>Error Sending Message!</span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
</div>
